import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// Constants
const getMaxWidth = (isFullWidth: boolean): string => (isFullWidth ? '1800px' : '760px');

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const VariableInputDrawerFooterWrapper = styled.div<{
	isFullWidth: boolean;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	maxWidth: (props) => getMaxWidth(props.isFullWidth),
	paddingRight: token('space.800'),
	display: 'flex',
	boxSizing: 'content-box',
	margin: '0 auto',
	justifyContent: 'flex-end',
	height: '80px',
	flexShrink: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const VariableInputDrawerHeader = styled.header<{
	isFullWidth: boolean;
}>({
	display: 'block',
	boxSizing: 'content-box',
	margin: '0 auto',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	maxWidth: (props) => getMaxWidth(props.isFullWidth),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const VariableInputDrawerPageHeaderWrapper = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> div': {
		marginTop: 0,
	},
});

// this removes AK's button background on hover
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const VariableInputDrawerButtonWrapper = styled.span({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'button:hover': {
		background: 'none',
	},
});

// CustomDrawer
// scroll test should catch if the drawer ever changes their 24px padding
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CustomDrawerWrapper = styled.div({
	height: '100%',
	display: 'flex',
	flexDirection: 'column',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CustomDrawerContentWrapper = styled.div({
	overflow: 'auto',
	flexGrow: 1,
	paddingRight: token('space.800'),
	paddingLeft: token('space.025'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FooterKeyline = styled.div({
	boxShadow: `inset ${token('color.border.disabled')} 0px 2px 0px 0px`,
});

// TemplateVariableInput
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TemplateVariableInputFieldWrapper = styled.span({
	display: 'inline-block',
	maxWidth: '100%',
	whiteSpace: 'initial',
});
// textareas push the rest of the content down when inline
// so it needs extra styling
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TemplateVariableTextareaInputFieldWrapper = styled.span({
	display: 'inline-block',
	maxWidth: '100%',
	position: 'relative',
	verticalAlign: 'top',
});

// atlaskit buttons text overlaps the popper dropdown
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ButtonStyle = styled.span({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& span': {
		position: 'unset',
	},
});
